import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addQuestionDomainApi, listOfQuestionDomainApi, updateQuestionDomainApi } from "../../../../../config/Api";
export const QuestionDomain = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [questionDomainData, setQuestionDomainData] = useState()
    const [editQuestionDomainRecord, setEditQuestionDomainRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all available QuestionDomain
    //==============================
    const getListOfQuestionDomain = () => {
        setLoading(true)

        listOfQuestionDomainApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editQuestionDomain = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'domain': data.domain })
        setEditQuestionDomainRecord(data);
    }

    useEffect(() => {
        getListOfQuestionDomain()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterQuestionDomain(questionDomainData);
    }, [questionDomainData]);

    // filter QuestionDomain
    //==============================
    const filterQuestionDomain = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.domain.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of QuestionDomain
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateQuestionDomainApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "QuestionDomain Update successfully",
                    });
                    getListOfQuestionDomain()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "domain": values.domain,
                "status": true
            }
            addQuestionDomainApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'domain': '' })
                        notification.success({
                            message: "QuestionDomain added successfully",
                        });
                        getListOfQuestionDomain()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "domain": values.domain,
                "status": values.status
            }
            updateQuestionDomainApi(editQuestionDomainRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Diseases Update successfully",
                        });
                        getListOfQuestionDomain()
                        form.setFieldsValue({ 'domain': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };


    const columns = [
        {
            title: 'Domain',
            dataIndex: 'domain',
            key: 'domain',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editQuestionDomain(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            domain: 'Lifestyle',
            status: true
        },
        {
            id: '2',
            domain: 'Activity',
            status: false
        },
        {
            id: '3',
            domain: 'Body Frame',
            status: true
        },
        {
            id: '4',
            domain: 'Appetite',
            status: false
        },
        {
            id: '5',
            domain: 'Digestion',
            status: true
        }
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="QuestionDomain">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addDomainForm"
                        // className="addRecipeTypes"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addDomainForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="domain"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Question Domain!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Question Domain" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total Domain:  {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Domain"
                        onChange={(e) => { filterQuestionDomain(e.target.value); setQuestionDomainData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        dataSource={displayData}
                        rowKey="id"
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
